import React, { useState } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import * as LoginActions from '$/store/login/actions';
import { connect } from 'react-redux';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import Login from './Login';
import { LOGIN_WELCOME_MESSAGE, LOGIN_EMAIL_PLACEHOLDER, LOGIN_PASSWORD_PLACEHOLDER } from '$/core/constants';
import { Navigate } from 'react-router-dom';

const login = LoginActions.login;

interface ILoginRouteProps {
  from?: string;
}

interface ILoginContainerProps extends ILoginRouteProps {
  dispatchLogin: (LoginRequest: Bixby.Models.LoginRequest) => Promise<void>;
  isLoading: boolean;
  isAuthenticated: boolean;
  error?: string;
}

const LoginContainer: React.FC<ILoginContainerProps> = props => {
  const { isLoading, isAuthenticated, error, dispatchLogin } = props;
  /** After login Bixby Admin in CS must land on admin page as that's all they should be able to see as of 2025-10-27 */
  const pathForRedirectOnAuth = Bixby.Configuration.isStandAloneMode ? '/portfolio' : '/admin';

  const match = useMatch('/login/:from?');
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginInProgress, setLoginInProgress] = useState(false);
  if (isAuthenticated && !loginInProgress) {
    const target =
      match && match.params.from ? decodeURIComponent(match.params.from) : pathForRedirectOnAuth + location.hash;
    return <Navigate to={target} />;
  }

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = (e: any) => {
    setPassword(e.target.value);
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoginInProgress(true);
    try {
      await dispatchLogin({
        email,
        password,
      });
    } catch {
      // error is handled via redux
    }
    setLoginInProgress(false);
  };

  return (
    <Login
      email={email}
      password={password}
      isLoading={loginInProgress || isLoading}
      onEmailChange={handleEmailChange}
      onPasswordChange={handlePasswordChange}
      onSubmit={handleSubmit}
      errorText={error}
      welcomeMessage={LOGIN_WELCOME_MESSAGE}
      emailPlaceholder={LOGIN_EMAIL_PLACEHOLDER}
      passwordPlaceholder={LOGIN_PASSWORD_PLACEHOLDER}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.loginState.isLoading,
    isAuthenticated: state.loginState.authenticated === true,
    error: state.loginState.error,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchLogin: (cmd: Bixby.Models.LoginRequest) => dispatch(login(cmd)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
